firebird.controller('reactionsAnimationCtrl', [
    '$window',
    '$scope',
    '$rootScope',
    '$timeout',
    '$interval',
    'logService',
    'meetingService',
    'attendeeListService',
    'helperService',
    'themedFeaturesService',
    function (
        $window,
        $scope,
        $rootScope,
        $timeout,
        $interval,
        logService,
        meetingService,
        attendeeListService,
        helperService,
        themedFeaturesService
    ) {
        var self = this,
            app,
            canvas,
            context,
            width,
            height,
            reactionImg,
            reactionParticles = [],
            allReactions = ['smile', 'thumbsup', 'thumbsdown', 'love', 'sad', 'laughter', 'wow', 'applause'],
            // Stationary VDI tray (ANYAM-123367): shown while any reaction or raised-hand emoji is inside
            // #reactions-animation; vdiService mirrors it with one clip rect via 'reactions-tray-visible'.
            trayVisible = false,
            trayObserver = null,
            trayListenerAttached = false,
            trayHideTimeout = null,
            // Paced queue for the single-row chip: items wait hidden (.queued) and show one at a time (.showing).
            trayQueue = [],
            trayShowing = null,
            trayShowStart = 0,
            trayLeaveTimeout = null,
            trayShowFallbackTimeout = null;
        // Keeps the tray (and its clip rect) up across back-to-back items instead of flickering; short, since
        // the queue already holds the chip open while anything is waiting.
        var TRAY_HIDE_LINGER_MS = 120;
        // An item gets its full ~4s animation when alone, but yields after this long once something is waiting.
        var TRAY_MIN_SHOW_MS = 2000;
        // If a shown item's exit animationend never arrives (node detached mid-animation, hidden tab...), drop it
        // anyway so the queue can't stall with an empty chip. Slightly longer than the ~4s natural lifecycle.
        var TRAY_SHOW_FALLBACK_MS = 4800;
        // Beyond this backlog the oldest waiting reactions are dropped (hands are kept).
        var TRAY_MAX_PENDING = 8;
        // Items still holding the chip open. '.gone' = a hand that already left but whose DOM node the
        // hand-raise service only removes on its own timer.
        var TRAY_CONTENT_SELECTOR = '.emoji-name-container:not(.gone), .hand-raise-list-container .animator:not(.gone)';
        var TRAY_ITEM_SELECTOR = '.emoji-name-container, .hand-raise-list-container .animator';
        const logger = logService.createLoggerWithSource('reactionsAnimationCtrl');

        self.getReactionsList = getReactionsList;

        self.showReactionsAnimation = showReactionsAnimation;
        self.reactionsEnabled = meetingService.getWebinarOptions().showReactionsAnimation;
        self.animationFrameID = null;

        self.startDrawLoop = startDrawLoop;
        self.continueDrawLoop = continueDrawLoop;
        self.stopDrawLoop = stopDrawLoop;

        self.meetingReactionsEnabled = meetingService.isMeeting();

        self.addReactions = addReactions;
        self.useCanvasDrawing = false;
        self.getReactions = getReactions;
        self.usesStationaryTray = usesStationaryTray;

        self.inCompactMode = false;

        $scope.$on('attendee-partial-property', onAttendeePartialProperty);
        $scope.$on('webinar-options-updated', onWebinarOptionsUpdated);
        $scope.$on('enable-compact-mode', onCompactModeReceived);
        $scope.$on('$destroy', onDestroy);

        init();

        ////////////////////////

        function init() {
            logger.debug('init reactionsAnimationCtrl', self.meetingReactionsEnabled);
            self.useCanvasDrawing = helperService.getQueryParameter('useCanvasDrawing') == 'true';
            //Watch for changes on window resize
            if (meetingService.isWebinar()) {
                angular.element($window).bind('resize', function () {
                    if (width && canvas) {
                        var newWidth = $window.innerWidth >= 1200 ? $window.innerWidth - 300 : $window.innerWidth;
                        width = canvas.width = newWidth;

                        //Styles don't seem to persist after changing canvas width, so we re-apply them
                        applyContextStyles();
                    }
                });
            }

            $timeout(function () {
                // Get Canvas Block and Context
                app = $window.document.getElementById('reactions-animation');
                canvas = $window.document.getElementById('reactions-canvas');
                context = canvas.getContext('2d');

                // Set width and height
                width = canvas.width = app.offsetWidth;
                canvas.style.height = '100%';
                height = canvas.height = app.offsetHeight;
                // Set Image for Canvas
                reactionImg = new Image();

                if (meetingService.isMeeting()) {
                    reactionImg.src = 'img/redesign/icons/reactions/all_reactions_meeting.png';
                } else {
                    reactionImg.src = 'img/reactions/all_reactions.png';
                }

                // Style for attendee name
                applyContextStyles();

                if (usesStationaryTray()) {
                    enableStationaryTray();
                }

                // Draw Reactions
                if (!meetingService.isMeeting()) {
                    if (self.reactionsEnabled) {
                        self.startDrawLoop();
                    }
                } else {
                    if (self.meetingReactionsEnabled) {
                        self.startDrawLoop();
                    }
                }
            });
        }

        function applyContextStyles() {
            if (context) {
                if (meetingService.isWebinar()) {
                    context.font = '12px';
                } else {
                    context.font = '13px noto-sans';
                }
                context.fillStyle = 'white';
                context.shadowColor = 'rgba(0,0,0,0.7)';
                context.shadowOffsetX = 1;
                context.shadowOffsetY = 1;
                context.shadowBlur = 1;
            }
        }

        function onAttendeePartialProperty(e, data) {
            if (meetingService.isWebinar()) {
                if (!self.reactionsEnabled) {
                    return;
                }
            } else if (!self.meetingReactionsEnabled) {
                return;
            }

            if (!helperService.getVDIRef().showReactionButton) {
                return;
            }

            if (data.propName && data.propName === 'currentReaction') {
                var name = data.screenName || '';
                var maxReactions = 50;

                if (reactionParticles.length < maxReactions && meetingService.isMeeting()) {
                    reactionParticles.push(new newReaction(data.propValue, name));
                } else if (data.propValue !== 'none' && reactionParticles.length < maxReactions) {
                    reactionParticles.push(new newReaction(data.propValue, name));
                }
            }
        }

        function addReactions(name, numbers, delay) {
            if (numbers && numbers > 0) {
                for (var i = 0; i < numbers; i++) {
                    $timeout(function () {
                        /* jshint ignore:start */
                        let reactionsList = self.getReactionsList();
                        var randomReaction = reactionsList[Math.floor(reactionsList.length * Math.random())];
                        reactionParticles.push(new newReaction(randomReaction, name));
                        /* jshint ignore:end */
                    }, delay * i);
                }
            }
        }

        function getReactions() {
            return reactionParticles;
        }

        function randomize(min, max) {
            return Math.random() * (max - min) + min;
        }

        function newReaction(reaction, name) {
            // Randomize start x and y position for New Reaction
            if (meetingService.isWebinar()) {
                this.x = width + Math.round(randomize(20, 60));
                this.y = height - Math.round(randomize(40, 100));
                this.amplitude = randomize(0.2, 0.4);
                // Needed for the animation to slowly fade out-- only used in webinars
                this.opacity = 1;
            } else {
                this.x = Math.round(randomize(-20, -60));
                this.y = height - Math.round(randomize(20, 40));
                this.amplitude = randomize(0.05, 0.1);
            }
            this.counter = 0;

            // Randomize Speed
            var speedMin = (width / 400) * 1.2;
            var speedMax = (width / 400) * 1.8;
            this.speed = randomize(speedMin, speedMax);
            this.exiting = false;

            // Randomize Reaction Radius
            //this used to be to take a random variable, that would make emojis vary in size
            //ANYAM-69246 removed that variation so all emojis remain the same size and are the largest ones
            this.scaleX = 0.8;
            this.scaleY = this.scaleX;

            this.width = 50 * this.scaleX;

            // Set Reaction Image
            this.reactionType = self.getReactionsList().indexOf(reaction);

            this.text = name;
            //this is how the names are seperated into two separate strings to be displayed
            var nameArray = name.split(' ');
            this.firstName = nameArray[0];
            var firstNameLength = this.firstName.length;
            //Add the +1 to deal with the leading space after if it is two names
            this.restOfName = name.slice(firstNameLength + 1);
            this.startingDirectionUp = Math.random() >= 0.5;

            this.waveLength = width / randomize(8, 10);

            if (meetingService.isMeeting() && !self.useCanvasDrawing) {
                var stationary = usesStationaryTray();
                var reactionElement = $($('#reaction-template').html());
                if (!self.inCompactMode && !stationary) {
                    reactionElement.css('transform', 'scale(' + (Math.random() * 0.3 + 1) + ')');
                    reactionElement.css('animation-duration', Math.floor(Math.random() * 3 + 4) + 's');
                }

                reactionElement.find('.first-name').text(this.firstName);
                reactionElement.find('.last-name').text(this.restOfName);
                reactionElement.find('.reaction-emoji').addClass('react-' + reaction);
                reactionElement.on('animationend', function (evt) {
                    if (stationary) {
                        // Tray items are removed by onTrayItemAnimationEnd (delegated), which also paces the queue.
                        return;
                    }
                    // Compact mode chains several animations; only the last one (the exit) removes.
                    if (self.inCompactMode) {
                        if (evt.originalEvent.animationName === 'compact_shiftUp') {
                            $(reactionElement).remove();
                            reactionParticles.splice(0, 1);
                        }
                    } else {
                        $(reactionElement).remove();
                        reactionParticles.splice(0, 1);
                    }
                });
                $timeout(function () {
                    reactionElement.addClass('active');
                }, 100);
                reactionElement.appendTo(app);
            }
        }

        // Only the meeting DOM path (newReaction appends elements) feeds the chip; webinars and the
        // ?useCanvasDrawing=true debug path draw on the canvas, which the tray CSS hides.
        function usesStationaryTray() {
            var vdiRef = helperService.getVDIRef && helperService.getVDIRef();
            return (
                meetingService.isMeeting() &&
                !self.useCanvasDrawing &&
                !!vdiRef &&
                vdiRef.showAnimatedOverlaysOverVideo === false
            );
        }

        // Watches the tray's children (reaction elements appended above, raised-hand emojis rendered by the
        // <hand-raise-list-animator placement="tray"> inside it) so both drive the same visibility.
        function enableStationaryTray() {
            $(app).addClass('vdi-stationary');
            app.addEventListener('animationend', onTrayItemAnimationEnd);
            trayListenerAttached = true;
            if (typeof MutationObserver === 'undefined') {
                return;
            }
            trayObserver = new MutationObserver(onTrayMutations);
            trayObserver.observe(app, { childList: true, subtree: true });
            updateTrayState();
        }

        // The chip shows one item at a time. New items (reaction elements appended above, raised-hand emojis
        // rendered by <hand-raise-list-animator placement="tray">) are queued hidden and promoted in order;
        // the one showing yields early once something is waiting. A fixed single-row chip keeps the clip
        // rect constant, and nothing is skipped short of a flood (TRAY_MAX_PENDING).
        function onTrayMutations(records) {
            records.forEach(function (record) {
                // Hands are removed by the hand-raise service's own timer / Angular re-render, not by us: a
                // tracked node that disappears must leave the queue, or a detached trayShowing (which never
                // fires animationend) would stall everything behind it with an empty chip.
                Array.prototype.forEach.call(record.removedNodes, function (node) {
                    if (node.nodeType !== 1) {
                        return;
                    }
                    trackedTrayItems().forEach(function (item) {
                        if (node === item || node.contains(item)) {
                            dismissTrayItem(item);
                        }
                    });
                });
                Array.prototype.forEach.call(record.addedNodes, function (node) {
                    if (node.nodeType !== 1) {
                        return;
                    }
                    var item = node.matches(TRAY_ITEM_SELECTOR) ? node : node.closest(TRAY_ITEM_SELECTOR);
                    if (!item || !app.contains(item) || item.classList.contains('queued') || item === trayShowing) {
                        return;
                    }
                    item.classList.add('queued');
                    trayQueue.push(item);
                });
            });
            // Flood control trims waiting reactions only; a backlog made purely of hands is kept whole.
            while (trayQueue.length > TRAY_MAX_PENDING) {
                var dropped = trayQueue.find(function (item) {
                    return item.classList.contains('emoji-name-container');
                });
                if (!dropped) {
                    break;
                }
                dismissTrayItem(dropped);
            }
            updateTrayState();
            advanceTray();
        }

        function trackedTrayItems() {
            return trayShowing ? trayQueue.concat([trayShowing]) : trayQueue.slice();
        }

        function advanceTray() {
            if (trayShowing) {
                if (trayQueue.length) {
                    scheduleTrayLeave();
                }
                return;
            }
            var next = trayQueue.shift();
            while (next && !app.contains(next)) {
                next = trayQueue.shift();
            }
            if (!next) {
                return;
            }
            next.classList.remove('queued');
            next.classList.add('showing');
            trayShowing = next;
            trayShowStart = Date.now();
            trayShowFallbackTimeout = $timeout(function () {
                trayShowFallbackTimeout = null;
                if (trayShowing === next) {
                    dismissTrayItem(next);
                    updateTrayState();
                    advanceTray();
                }
            }, TRAY_SHOW_FALLBACK_MS);
            if (trayQueue.length) {
                scheduleTrayLeave();
            }
        }

        function scheduleTrayLeave() {
            if (trayLeaveTimeout) {
                return;
            }
            var delay = Math.max(0, TRAY_MIN_SHOW_MS - (Date.now() - trayShowStart));
            trayLeaveTimeout = $timeout(function () {
                trayLeaveTimeout = null;
                if (trayShowing) {
                    trayShowing.classList.add('leaving');
                }
            }, delay);
        }

        // Fires for the item's own chained animations; only its exits matter: natural rise-out, early leave,
        // or - when compact mode took over while the tray is active - the compact exit.
        function onTrayItemAnimationEnd(evt) {
            // Angular emits component keyframes as '_ngcontent-xxx_trayRiseOut' (prefix), so match anywhere.
            var name = evt.animationName || '';
            if (
                name.indexOf('trayRiseOut') === -1 &&
                name.indexOf('trayLeave') === -1 &&
                name.indexOf('compact_shiftUp') === -1
            ) {
                return;
            }
            var item = evt.target.matches(TRAY_ITEM_SELECTOR) ? evt.target : null;
            if (item) {
                dismissTrayItem(item);
                updateTrayState();
                advanceTray();
            }
        }

        // Reactions own their DOM and are removed outright. Hands belong to <hand-raise-list-animator>: hide
        // them now (.gone) and tell the component, which removes the node and clears its per-attendee dedupe.
        function dismissTrayItem(item) {
            var queueIndex = trayQueue.indexOf(item);
            if (queueIndex !== -1) {
                trayQueue.splice(queueIndex, 1);
            }
            if (item === trayShowing) {
                trayShowing = null;
                $timeout.cancel(trayLeaveTimeout);
                trayLeaveTimeout = null;
                $timeout.cancel(trayShowFallbackTimeout);
                trayShowFallbackTimeout = null;
            }
            if (item.classList.contains('emoji-name-container')) {
                if (item.parentNode) {
                    $(item).remove();
                    reactionParticles.splice(0, 1);
                }
            } else {
                item.classList.remove('queued', 'showing', 'leaving');
                item.classList.add('gone');
                item.dispatchEvent(new CustomEvent('tray-item-dismissed'));
            }
        }

        function updateTrayState() {
            var hasContent = !self.inCompactMode && !!app.querySelector(TRAY_CONTENT_SELECTOR);
            if (hasContent) {
                $timeout.cancel(trayHideTimeout);
                trayHideTimeout = null;
                setTrayVisible(true);
            } else if (self.inCompactMode) {
                // Compact mode swaps the chip for the 336x189 compact container; a lingering clip rect would be
                // re-measured against that and cover the video, so drop it right away.
                $timeout.cancel(trayHideTimeout);
                trayHideTimeout = null;
                setTrayVisible(false);
            } else if (trayVisible && !trayHideTimeout) {
                trayHideTimeout = $timeout(function () {
                    trayHideTimeout = null;
                    if (!self.inCompactMode && !app.querySelector(TRAY_CONTENT_SELECTOR)) {
                        setTrayVisible(false);
                    }
                }, TRAY_HIDE_LINGER_MS);
            }
        }

        function setTrayVisible(visible) {
            if (visible === trayVisible) {
                return;
            }
            trayVisible = visible;
            $(app).toggleClass('has-content', visible);
            $rootScope.$broadcast('reactions-tray-visible', visible);
        }

        function onDestroy() {
            if (trayObserver) {
                trayObserver.disconnect();
                trayObserver = null;
            }
            if (trayListenerAttached) {
                app.removeEventListener('animationend', onTrayItemAnimationEnd);
                trayListenerAttached = false;
            }
            // Hands have no timer of their own on the tray path; tell the hand-raise service to drop them.
            trackedTrayItems().forEach(dismissTrayItem);
            $timeout.cancel(trayLeaveTimeout);
            trayLeaveTimeout = null;
            $timeout.cancel(trayShowFallbackTimeout);
            trayShowFallbackTimeout = null;
            trayQueue = [];
            trayShowing = null;
            $timeout.cancel(trayHideTimeout);
            setTrayVisible(false);
        }

        function draw() {
            //meeting should be using new emoji implementation
            if (meetingService.isMeeting() && !self.useCanvasDrawing) {
                return;
            }

            // Clear Context Rectangle
            if (reactionParticles.length > 0) {
                context.clearRect(0, 0, width, height);
            }

            for (var i = 0; i < reactionParticles.length; i++) {
                var p = reactionParticles[i];

                // Last Path Animation
                if (meetingService.isWebinar()) {
                    // Center and show AttendeeName for Reactions
                    var textWidth = context.measureText(p.text).width;
                    var getCenterPosition = (textWidth - p.width) / 2;
                    context.fillStyle = 'rgba(255,255,255,' + p.opacity + ')';
                    context.fillText(p.text, p.x - getCenterPosition, p.y);
                    if (p.x < width / 4) {
                        if (!p.exiting) {
                            p.exiting = true;
                        }

                        var webinarScale = width / 4 / 100;

                        p.scaleX -= 0.01 / webinarScale;
                        p.scaleY -= 0.01 / webinarScale;

                        p.x -= 0.5;
                    }

                    if (p.x < width * 0.66) {
                        p.opacity = p.x / (width * 0.66);

                        if (p.opacity < 0) {
                            p.opacity = 0;
                        }
                    }

                    // ** Wave Path Animation **
                    if (p.startingDirectionUp) {
                        p.y = Math.sin(p.x / p.waveLength) * (height / 2) * p.amplitude + height / 2;
                    } else {
                        p.y = Math.cos(p.x / p.waveLength) * (height / 2) * p.amplitude + height / 2;
                    }

                    // Remove element from Array
                    var xWebinarLimit = -10;
                    if (p.x < xWebinarLimit) {
                        var nextWebinarParticle = reactionParticles[i + 1];

                        if (nextWebinarParticle) {
                            if (nextWebinarParticle.x < xWebinarLimit) {
                                reactionParticles.splice(i, 1);
                            }
                        } else {
                            reactionParticles.splice(i, 1);
                        }
                    }

                    p.x -= p.speed;
                } else {
                    //this is because the p.x value is not precisely on the emoji's starting point
                    var startingOffset = p.x + 3;
                    //Only add the bottom half if the user has more than one name as their meeting name
                    if (p.restOfName) {
                        var restOfNameWidth = context.measureText(p.restOfName).width;
                        var getRestOfNameCenterPosition = (restOfNameWidth - p.width) / 2;
                        context.fillText(p.restOfName, startingOffset - getRestOfNameCenterPosition, p.y - 5);
                    }
                    //This is the meeting UI change where the words are split into first and last/restOf name
                    var firstNameWidth = context.measureText(p.firstName).width;

                    var getFirstNameCenterPosition = (firstNameWidth - p.width) / 2;
                    context.fillStyle = 'rgba(255,255,255)';

                    //Need two separate fillTexts so that both names can be centered on different lines
                    //The other fillText occurs if the user has more than one name
                    context.fillText(p.firstName, startingOffset - getFirstNameCenterPosition, p.y - 20);
                    if (p.x > width - width / 4) {
                        if (!p.exiting) {
                            p.exiting = true;
                        }

                        var meetingScale = width / 4 / 100;

                        p.scaleX -= 0.01 / meetingScale;
                        p.scaleY -= 0.01 / meetingScale;

                        p.x += 0.5;
                    }

                    var offsetHeight = height / 6;
                    // ** Wave Path Animation **
                    if (p.startingDirectionUp) {
                        p.y = Math.sin(p.x / p.waveLength) * (height / 2) * p.amplitude + height / 2 + offsetHeight;
                    } else {
                        p.y = Math.cos(p.x / p.waveLength) * (height / 2) * p.amplitude + height / 2 + offsetHeight;
                    }

                    // Remove element from Array
                    var xMeetingLimit = width + 10;
                    if (p.x > xMeetingLimit) {
                        var nextMeetingParticle = reactionParticles[i + 1];

                        if (nextMeetingParticle) {
                            if (nextMeetingParticle.x > xMeetingLimit) {
                                reactionParticles.splice(i, 1);
                            }
                        } else {
                            reactionParticles.splice(i, 1);
                        }
                    }

                    p.x += p.speed;
                }

                // Drawing state that gets saved
                context.save();

                // Last 100px Path Animation
                context.globalAlpha = p.opacity;

                // Set Image and Size for Reaction
                context.setTransform(p.scaleX, 0, 0, p.scaleY, p.x, p.y);
                context.drawImage(reactionImg, p.reactionType * 50, 0, 40, 40, 0, 0, 50, 50);

                // Restore State to saved
                context.restore();
            }

            self.continueDrawLoop();
        }

        function startDrawLoop() {
            if (!self.animationFrameID) {
                self.animationFrameID = $window.requestAnimationFrame(draw);
            }
        }

        function continueDrawLoop() {
            if (meetingService.isWebinar()) {
                if (self.reactionsEnabled) {
                    self.animationFrameID = $window.requestAnimationFrame(draw);
                }
            } else {
                if (self.meetingReactionsEnabled) {
                    self.animationFrameID = $window.requestAnimationFrame(draw);
                }
            }
        }

        function stopDrawLoop() {
            if (self.animationFrameID) {
                //Draw one more time to remove reactions from screen
                reactionParticles = [];
                self.animationFrameID = $window.requestAnimationFrame(draw);

                $window.cancelAnimationFrame(self.animationFrameID);
                self.animationFrameID = null;
            }
        }

        function showReactionsAnimation() {
            return (
                (meetingService.getIsOnAir() && meetingService.getWebinarOptions().showReactionsAnimation) ||
                (meetingService.isMeeting() && self.meetingReactionsEnabled)
            );
        }

        function onWebinarOptionsUpdated() {
            //Only toggle canvas loop if value of showReactionsAnimation changed
            if (self.reactionsEnabled !== meetingService.getWebinarOptions().showReactionsAnimation) {
                self.reactionsEnabled = meetingService.getWebinarOptions().showReactionsAnimation;

                if (self.reactionsEnabled) {
                    self.startDrawLoop();
                } else {
                    self.stopDrawLoop();
                }

                digest();
            }
        }

        function getReactionsList() {
            if (themedFeaturesService.getThemedFeaturesEnabled()) {
                return themedFeaturesService.getThemedReactions().map(reaction => reaction.name);
            } else {
                return allReactions;
            }
        }

        function onCompactModeReceived(e, data) {
            self.inCompactMode = data;
            if (self.inCompactMode) {
                $('#reactions-animation').addClass('compact-mode');
            } else {
                $('#reactions-animation').removeClass('compact-mode');
            }
            if (trayObserver) {
                updateTrayState();
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
